import About from "../Sections/home/About";
import Features from "../Sections/home/Features";
import Jumbotron from "../Sections/home/Jumbotron";
import Vitrin from "../Sections/home/Vitrin";
import BestSeller from "../Sections/home/BestSeller";
import Testimonial from "../Sections/home/Testimonial";
import LastBlog from "../Sections/home/LastBlog";
import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";

function Home() {
    const { data: {home,id} } = useGetSettingQuery()

    return ( 
        <>
        {home.jumbotron && <Jumbotron/>}
        {home.vitrin && <Vitrin/>}
        {home.about && <About/>}
        {home.features && <Features/>}
        {home.best_seller && <BestSeller/>}
        {home.testimonial && <Testimonial/>}
        {home.last_blog && <LastBlog name={home.last_blog.name} site_id={id}/>}
        </>
    );
}

export default Home;